export { Tooltip as TableColumnTooltip } from '../core/enum';
export var ColumnLock;
(function (ColumnLock) {
    ColumnLock["left"] = "left";
    ColumnLock["right"] = "right";
})(ColumnLock || (ColumnLock = {}));
export var RowBoxPlacement;
(function (RowBoxPlacement) {
    RowBoxPlacement["start"] = "start";
    RowBoxPlacement["end"] = "end";
})(RowBoxPlacement || (RowBoxPlacement = {}));
export var ColumnAlign;
(function (ColumnAlign) {
    ColumnAlign["left"] = "left";
    ColumnAlign["center"] = "center";
    ColumnAlign["right"] = "right";
})(ColumnAlign || (ColumnAlign = {}));
export var DragColumnAlign;
(function (DragColumnAlign) {
    DragColumnAlign["left"] = "left";
    DragColumnAlign["right"] = "right";
})(DragColumnAlign || (DragColumnAlign = {}));
export var ScrollPosition;
(function (ScrollPosition) {
    ScrollPosition["left"] = "left";
    ScrollPosition["right"] = "right";
    ScrollPosition["both"] = "both";
    ScrollPosition["middle"] = "middle";
})(ScrollPosition || (ScrollPosition = {}));
export var SelectionMode;
(function (SelectionMode) {
    SelectionMode["rowbox"] = "rowbox";
    SelectionMode["treebox"] = "treebox";
    SelectionMode["click"] = "click";
    SelectionMode["none"] = "none";
    SelectionMode["dblclick"] = "dblclick";
    SelectionMode["mousedown"] = "mousedown";
})(SelectionMode || (SelectionMode = {}));
export var TableButtonType;
(function (TableButtonType) {
    TableButtonType["add"] = "add";
    TableButtonType["delete"] = "delete";
    TableButtonType["remove"] = "remove";
    TableButtonType["save"] = "save";
    TableButtonType["query"] = "query";
    TableButtonType["reset"] = "reset";
    TableButtonType["expandAll"] = "expandAll";
    TableButtonType["collapseAll"] = "collapseAll";
    TableButtonType["export"] = "export";
})(TableButtonType || (TableButtonType = {}));
export var TableCommandType;
(function (TableCommandType) {
    TableCommandType["edit"] = "edit";
    TableCommandType["delete"] = "delete";
})(TableCommandType || (TableCommandType = {}));
export var TableMode;
(function (TableMode) {
    TableMode["list"] = "list";
    TableMode["tree"] = "tree";
})(TableMode || (TableMode = {}));
export var TableEditMode;
(function (TableEditMode) {
    TableEditMode["cell"] = "cell";
    TableEditMode["inline"] = "inline";
})(TableEditMode || (TableEditMode = {}));
export var TableQueryBarType;
(function (TableQueryBarType) {
    TableQueryBarType["normal"] = "normal";
    TableQueryBarType["bar"] = "bar";
    TableQueryBarType["none"] = "none";
    TableQueryBarType["advancedBar"] = "advancedBar";
    TableQueryBarType["professionalBar"] = "professionalBar";
    TableQueryBarType["filterBar"] = "filterBar";
    TableQueryBarType["comboBar"] = "comboBar";
})(TableQueryBarType || (TableQueryBarType = {}));
export var TablePaginationPosition;
(function (TablePaginationPosition) {
    TablePaginationPosition["top"] = "top";
    TablePaginationPosition["bottom"] = "bottom";
    TablePaginationPosition["both"] = "both";
})(TablePaginationPosition || (TablePaginationPosition = {}));
export var TableHeightType;
(function (TableHeightType) {
    TableHeightType["auto"] = "auto";
    TableHeightType["fixed"] = "fixed";
    TableHeightType["flex"] = "flex";
})(TableHeightType || (TableHeightType = {}));
export var TableAutoHeightType;
(function (TableAutoHeightType) {
    TableAutoHeightType["maxHeight"] = "maxHeight";
    TableAutoHeightType["minHeight"] = "minHeight";
})(TableAutoHeightType || (TableAutoHeightType = {}));
export var HighLightRowType;
(function (HighLightRowType) {
    HighLightRowType["click"] = "click";
    HighLightRowType["focus"] = "focus";
})(HighLightRowType || (HighLightRowType = {}));
export var GroupType;
(function (GroupType) {
    GroupType["header"] = "header";
    GroupType["column"] = "column";
    GroupType["row"] = "row";
    GroupType["none"] = "none";
})(GroupType || (GroupType = {}));
export var TableColumnResizeTriggerType;
(function (TableColumnResizeTriggerType) {
    TableColumnResizeTriggerType["hover"] = "hover";
    TableColumnResizeTriggerType["mouseDown"] = "mouseDown";
})(TableColumnResizeTriggerType || (TableColumnResizeTriggerType = {}));
export var TableBoxSizing;
(function (TableBoxSizing) {
    TableBoxSizing["content"] = "content";
    TableBoxSizing["wrapper"] = "wrapper";
})(TableBoxSizing || (TableBoxSizing = {}));
